
















































































































































































import { Component, Emit, Prop, Watch, Vue } from 'vue-property-decorator'
import Moment from 'moment'
import CalculadoraVuex from '@/store/CalculadoraVuex'
import Assinatura from '@/store/Assinaturas'

@Component

export default class ComponentCalculadoraDialogSelectTabela extends Vue {
  @Prop(Array) portes
  @Prop(Array) tabelasCBHPM
  @Prop(Object) tabela

  tabelaWasUpdated: Boolean = false
  tabelaPorteWasUpdated: Boolean = false
  isEnableValorFixo: Boolean = false

  get isAssinaturaDemonstracao() {
    return Assinatura.getters.ASSINATURA_DEMONSTRACAO
  }

  get ativarTabelaCBHPM() {
    return CalculadoraVuex.getters.ATIVAR_VALORES_TABELA_CBHPM
  }

  set ativarTabelaCBHPM(newValue) {
    CalculadoraVuex.dispatch('SET_ATIVAR_VALORES_TABELA_CBHPM', newValue)
  }

  get tabelaPrecoSelected() {
    return CalculadoraVuex.getters.TABELA_PRECO_VERSAO
  }

  set tabelaPrecoSelected(newValue) {
    this.tabela.codigoTabelaReferencia = newValue
    CalculadoraVuex.dispatch('SET_TABELA_PRECO_VERSAO', newValue)
  }

  get getShow() {
    return CalculadoraVuex.getters.SHOW_CACULADORA_DIALOG_SELECT_TABELA
  }

  set getShow(value) {
    CalculadoraVuex.dispatch('SET_SHOW_CACULADORA_DIALOG_SELECT_TABELA', false)
  }

  redirectPlanos() {
    this.getShow = false
    this.redirect('/planos')
  }

  redirect(url): void {
    this.$router.push(url)
  }

  @Watch('show')
  onShowChanged() {
    this.tabelaWasUpdated = false
    this.tabelaPorteWasUpdated = false
  }

  @Watch('tabela.urgente')
  onTabelaUrgenteChanged(newValue) {
    if (newValue) this.tabela.fatorUrgencia = 130
    else this.tabela.fatorUrgencia = 100
  }

  @Watch('tabela.acomodacao')
  onTabelaAcomodacaoChanged(newValue) {
    if (newValue === 1) this.tabela.fatorAcomodacao = 200
    else this.tabela.fatorAcomodacao = 100
  }

  @Emit('clearValorBase')
  clearValorBase() {}

  @Emit('change')
  change() {
  }

  @Emit('close')
  close() {}

  @Emit('save')
  save(tabelaWasUpdated, tabelaPorteWasUpdated) {
    this.getShow = false
  }

  getPorteLabel(porte) {
    const label = `${porte.descricao} - ${porte.uco}`
    return label
  }
}
